import { render, staticRenderFns } from "./project.view.vue?vue&type=template&id=cb3c2c04&scoped=true&"
import script from "./project.view.vue?vue&type=script&lang=ts&"
export * from "./project.view.vue?vue&type=script&lang=ts&"
import style0 from "./project.view.vue?vue&type=style&index=0&id=cb3c2c04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3c2c04",
  null
  
)

export default component.exports